import { c as _c } from "react/compiler-runtime";
import GifPicker, { Theme } from "gif-picker-react";
import MobileWrapperDialog from "../mobile-wrapper-dialog/MobileWrapperDialog";
export default function CreateDropGifPicker(t0) {
  const $ = _c(11);
  const {
    tenorApiKey,
    show,
    setShow,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== setShow) {
    t1 = () => setShow(false);
    $[0] = setShow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onSelect) {
    t2 = gif => onSelect(gif.url);
    $[2] = onSelect;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== tenorApiKey) {
    t3 = <GifPicker width="100%" tenorApiKey={tenorApiKey} theme={Theme.DARK} onGifClick={t2} />;
    $[4] = t2;
    $[5] = tenorApiKey;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== show || $[8] !== t1 || $[9] !== t3) {
    t4 = <MobileWrapperDialog isOpen={show} onClose={t1} noPadding={true}>{t3}</MobileWrapperDialog>;
    $[7] = show;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}